export function logMsg(msg1, msg2) {
  if (console) {
    if (msg2) {
      console.log(msg1, msg2); // eslint-disable-line no-console
    } else {
      console.log(msg1); // eslint-disable-line no-console
    }
  }
}
